// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1VyU0","header":"ReportDetails_header__5ysSA","title":"ReportDetails_title__133wO","left":"ReportDetails_left__3wBBl"};